<template>
    <div
        class="links"
    >
        <Cta
            :post="post"
            v-for="post in layout.links"
        />
    </div>
</template>
<script>
import Cta from '@/components/layout/Links/Cta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.links
    max-width: 952px
    margin-top: 10%
    margin-bottom: 10%
    padding-left: 9.6%
    padding-right: 9.6%
    margin-left: auto
    margin-right: auto
    box-sizing: content-box
</style>
